import { type RefObject, useEffect, useState } from "react";
import { useWindowDimensionsContext } from "../../../../common-deprecated/containers/WindowDimensionsProvider";

export const useCalculateHeaderHeight = (ref: RefObject<HTMLElement>): number => {
    const [apheleiaNavHeight, setApheleiaNavHeight] = useState<number>(74);
    const windowWidth = useWindowDimensionsContext().width;

    useEffect(() => {
        setApheleiaNavHeight(ref.current?.getBoundingClientRect().height ?? 74);
    }, [ref.current, windowWidth]);

    return apheleiaNavHeight;
};
